import React, { PureComponent } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import Loader from 'src/ver2/components/loader';

import { Icon } from 'antd';
import { Link } from 'react-router-dom';

import { SCHOOLS_MAIN_TEXT, SCHOOLS_HOW_TO_ADD } from './text';
import SomeInfo from 'src/ver2/components/info';

import RegionsMap from 'src/ver2/components/regions/map';
import Pump from 'src/ver2/components/halloween';

import { SchoolPlaceRectMini } from 'src/ver2/components/place/school';
import './styles.css';

class SchoolsPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            schoolsInfo: {}
        }

    }

    componentDidMount() {
        this.loadInfo();
    }

    // loadInfo = async () => {
    //     const { client } = this.props;
    //     const { state: { schools } } = client;

    //     let schoolsInfo = {};

    //     for (let i = 0; i < Object.keys(schools).length; i++) {
    //         const schoolKey = Object.keys(schools)[i];
    //         const personsCount = await client.getSchoolPersonCount(schoolKey);
    //         schoolsInfo[schoolKey] = {
    //             personsCount
    //         }
    //     }

    //     this.setState({
    //         schoolsInfo,
    //         status: 'loaded',
    //     })
    // }

    loadInfo = async () => {
        const { client } = this.props;
        const { state: { schools } } = client;

        let schoolsInfo = {};

        const schoolsCount = await client.getSchoolPersonCount();
        let allSchoolsKeys = Object.keys(schools);


        console.log('SCHOOLS');

        for (let i = 0; i < schoolsCount.length; i++) {
            const schoolKey = schoolsCount[i].SchoolId;
            const personsCount = schoolsCount[i].PersonsCount;
            schoolsInfo[schoolKey] = {
                personsCount
            }
            const index = allSchoolsKeys.indexOf(schoolKey.toString());
            allSchoolsKeys.splice(index, 1);
        }

        for (let i = 0; i < allSchoolsKeys.length; i++) {
            const schoolKey = allSchoolsKeys[i];
            const personsCount = 0;
            schoolsInfo[schoolKey] = {
                personsCount
            }
        }

        this.setState({
            schoolsInfo,
            status: 'loaded',
        })
    }

    render() {

        const { isMobile } = this.props;

        const width = isMobile ? isMobile.width : 1200;
        const cardHeight = isMobile ? 120 : 270;

        const { status, schoolsInfo } = this.state;

        if (status === 'loading') return <div style={{ width, height: 700 }} className='schools_page'>
            <Loader />
        </div>

        const { client, showInfoModal } = this.props;

        const { regions, state: { schools } } = client;

        let schoolsInfo_ = Object.keys(schoolsInfo);
        schoolsInfo_ = schoolsInfo_.sort((a, b) => schoolsInfo[b].personsCount - schoolsInfo[a].personsCount);

        if (client && client.helloweenMode)
            schoolsInfo_.splice(18, 0, "HALLOWEEN");

        return <div style={{ width }} className='schools_page'>
            <div className='schools_page_text global_discribe_text'>
                {SCHOOLS_MAIN_TEXT(schoolsInfo_.length - 1)}
            </div>
            <SomeInfo content='Как добавить свою школу на Портал?' {...SCHOOLS_HOW_TO_ADD} />

            <div className='schools_page_schools'>
                {schoolsInfo_.map((schoolKey, index) => {
                    const animationDelay = `${index * 0.1}s`;

                    const DownedContent = schoolsInfo[schoolKey] ? <div className=''>
                        <span> <Icon type="user" className='schools_page_schools_one_icon' /> {schoolsInfo[schoolKey].personsCount}</span>
                    </div> : null;

                    if (schoolKey === '50') return null;

                    if (schoolKey === 'HALLOWEEN') {
                        return <div key={`spss-${index}`} style={{ animationDelay }} className='schools_page_schools_one'>
                            <div className='school_place_rect_mini' style={{ height: cardHeight }}>
                                <Pump width={ cardHeight * 0.74 } pumpCode={'kalopsd'} />
                            </div>
                        </div>
                    }

                    return <Link to={`/school/${schoolKey}/info`}>
                        <div key={`spss-${index}`} style={{ animationDelay }} className='schools_page_schools_one'>
                            <SchoolPlaceRectMini School={schools[schoolKey]} height={cardHeight} downedContent={DownedContent} />
                        </div>
                    </Link>
                })}
            </div>
            <div>
                {!isMobile && <RegionsMap width={width} />}
                {/* <RegionsMap width = {width/2} /> */}
            </div>
        </div>
    }
}


export default withCapoeiraSportState('client, showInfoModal, isMobile')(SchoolsPage);